import React, { useEffect, useState } from "react";
import { images } from "../../assests/imageExport/ImageExports";
import { useNavigate } from "react-router-dom";
import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import useGetApi from "../../services/useGetApi";
import { image_base_url } from "../../constants/Constant";
import PhoneImage from "../../assests/images/home/Phone.svg";
import EmailImage from "../../assests/images/home/Letter.svg";
import HeroImage from "../../assests/images/home/back.jpg";
import Lmslogo from "../../assests/images/home/logo.png";
import CtaImage from "../../assests/images/home/banner.jpg";
import BenefitImage from "../../assests/images/home/online.png";
import BenefitImage2 from "../../assests/images/home/expart.png";
import BenefitImage3 from "../../assests/images/home/smart.png";
import BenefitImage4 from "../../assests/images/home/Excellence.png";
import BenefitImage5 from "../../assests/images/home/Customization.png";
import BenefitImage6 from "../../assests/images/home/Integration.png";
import JoinNow from "../../assests/images/home/Arrow_Right_MD.svg";
import ProfileMenu from "../ProfileSection/ProfileMenu";
import { useAuth } from "../../user/context/AuthContext";
import Footer from "../footer/Footer";
import facebookImg from "../../assests/images/face.svg";
import instagram from "../../assests/images/insta.svg";
import youtube from "../../assests/images/youtube.svg";
import linkedin from "../../assests/images/linkd.svg";
import { Link } from "react-router-dom";
import { Drawer, Button, Dropdown, Menu } from "antd";
import { MenuOutlined } from "@ant-design/icons";

const Body = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState();
  const { isAuthenticated } = useAuth();
  const { confirmLogout, token } = useAuth();

  const [open, setOpen] = useState(false);
  const isAuth = isAuthenticated();


  //calculate window inner widht here
   const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const [isLoading, error, instructors, getData] = useGetApi(
    `users/getInstructors`,
    [],
    true
  );


  const searchCourse = () => {
    navigate(`/search?query=${searchValue}`);
  };

  useEffect(() => {
    getData(`users/getInstructors`);
  }, []);

  const navigateToSignup = () => {
    navigate("/signup");
  };
  const contactPage = () => {
    navigate("/contact");
  };
  const handleCourse = () => {
    setOpen(false)
    navigate("/courses");
  };
  const handleMyCourse = () => {
    setOpen(false)
    navigate("/user/my-courses");
  };
  const handlePolicy = () => {
    navigate("/privacy_policy");
  };
  const handleLogin = () => {
    navigate("/login");
  };
  const handleSignup = () => {
    navigate("/signin");
  };
  const handleHome = () => {
    navigate("/");
  };
  const handleTerms = () => {
    navigate("/terms_and_conditions");
  };
  const handleLogo = () => {
    navigate("/");
  };
  const handleSignInClick = () => {
    navigate("/signin");
  };
  const handleSignUpClick = () => {
    navigate("/signup");
  };

  const handleLogout = () => {
    confirmLogout()
  }

  if(isLoading) {
    return 
  }

 const handleWishlist = () => {
  setOpen(false)
  navigate("/user/my-wishlist")
 }

 const handleMessage = () => {
  setOpen(false)
  navigate("/user/messages")
 }

 const handleProfile = () => {
  setOpen(false)
  navigate("/user/user-profile")
 }

 const handleAccount = () => {
  setOpen(false)
  navigate("/user/account")
 }


 const items = [
  {
    key: 'signIn',
    label: (
      <span onClick={handleSignInClick}>
        Sign In
      </span>
    ),
  },
  {
    key: 'signUp',
    label: (
      <span onClick={handleSignUpClick}>
        Sign Up
      </span>
    ),
  },
  {
    key: 'adminLogin',
    label: (
      <a href="https://adminpanel.taggeo.in/login" target="_blank" rel="noopener noreferrer">
        Admin Login
      </a>
    ),
  },
];

  return (
    
    <>
      <div className="lms-landing">
        {/* Top Contact Bar */}
        <header className="contact-bar">
          <div className="contact-container">
            <div className="contact-info">
              <img src={PhoneImage} alt="Phone Icon" className="icon" />
              {/* <img
                src={facebookImg}
                alt="Phone Icon"
                className="icon"
                style={{backgroundColor:'white'}}
              /> */}
              <span className="phone-number">91-1234567890</span>
              <img src={EmailImage} alt="Email Icon" className="icon" />
              <a href="mailto:admissions@example.com" className="email-link">
                admissions@example.com
              </a>
            </div>
          </div>
          <div className="social-icons">
            <img
              src={facebookImg}
              alt="Email Icon"
              style={{ backgroundColor: "white" }}
            />
            <img
              src={instagram}
              alt="Email Icon"
              // style={{backgroundColor:'white'}}
            />
            <img
              src={youtube}
              alt="Email Icon"
              // style={{backgroundColor:'white'}}
            />
            <img
              src={linkedin}
              alt="Email Icon"
              // style={{backgroundColor:'white'}}
            />
          </div>
        </header>

          <section className="hero-section">
            <img src={HeroImage} alt="Hero" className="hero-background" />

            <div className="hero-container">
              <div className="nav-container">
                <p style={{ color: "white" }}>logo</p>

                <nav className="main-nav desktop-nav">
                  <div className="nav-group">
                    <a onClick={handleHome} className="nav-link">Home</a>
                    <a onClick={handleMyCourse} className="nav-link">My Courses</a>
                  </div>
                  <div className="nav-group">
                    <a onClick={handleCourse} className="nav-link">Courses</a>
                    <a onClick={contactPage} className="nav-link">Contact us</a>
                  </div>
                </nav>

                
                <div className="auth-section desktop-nav">
                  {isAuth ? (
                    <ProfileMenu />
                  ) : (
                    <Dropdown menu={{ items }} trigger={['click']} >
                      <Button type="text" style={{backgroundColor:"white",padding:"20px"}}> 
                        Sign In / Sign Up <DownOutlined />
                      </Button>
                    </Dropdown>
                  )}
                </div>
              
              {
                width <= 768 &&   
                <MenuOutlined onClick={() => setOpen(true)} />
              }

            
                <Drawer
                  placement="right"
                  onClose={() => setOpen(false)}
                  open={open}
                >
                  <a onClick={handleHome} className="sidebar_content">Home</a><br />
                  <a onClick={handleMyCourse} className="sidebar_content">My Courses</a><br />
                  <a onClick={handleCourse} className="sidebar_content" >Courses</a><br />
                  <a onClick={contactPage} className="sidebar_content">Contact us</a><br />
                  {!isAuthenticated() ? (
                    <div>
                      <button onClick={handleSignInClick} className="sidebar_content signin-button">Sign In</button>
                      <br />
                      <button onClick={handleSignUpClick} className="sidebar_content signout-button">Sign Up</button>
                    </div>
                  ) : (
                    <div>
                      <a onClick={handleWishlist} className="sidebar_content">My wishlist</a><br />
                      <a onClick={handleMessage} className="sidebar_content">My messages</a><br />
                      <a onClick={handleProfile} className="sidebar_content">My profile</a><br />
                      <a onClick={handleAccount} className="sidebar_content">Account</a><br />
                      <button onClick={handleLogout} className="sidebar_content logout-button">Logout</button>
                    </div>
                
                  )}
                </Drawer>
                </div>
                  <h1 className="hero-title">
                    Empower your learning
                    <br />
                    journey now
                  </h1>
                  <p className="hero-description">
                      Discover limitless learning opportunities with thousands of
                      courses available anytime, anywhere, all at unbeatable prices
                  </p>
                </div>
          </section>
        
        {/* Hero Section */}

        {/* <section className="hero-section">
          <div className="hero-container">
            <img src={HeroImage} alt="LMS Logo" className="hero-background " />
            <div className="nav-container">
              <img
                src={Lmslogo}
                alt="LMS Logo"
                className="logo cursor-pointer"
                onClick={handleLogo}
              /><p style={{color:'white'}}>logo</p>
              <nav className="main-nav">
                <div className="nav-group">
                  <a onClick={handleHome} className="nav-link cursor-pointer">
                    Home
                  </a>
                  <a
                    onClick={handleMyCourse}
                    className="nav-link cursor-pointer"
                  >
                    My Courses
                  </a>
                </div>
                <div className="nav-group">
                  <a onClick={handleCourse} className="nav-link cursor-pointer">
                    Courses
                  </a>
                  <a onClick={contactPage} className="nav-link cursor-pointer">
                    Contact us
                  </a>
                </div>
              </nav>
              <div>
                <div>
                  {isAuthenticated() ? (
                    <div className="navbar_right">
                      <ProfileMenu />
                    </div>
                  ) : (
                    <div className="dropdown">
                      <button className="dropdown-toggle" trigger={['click']}>
                        Sign In / Sign Up ▾
                      </button>
                      <div className="dropdown-menu">
                        <span
                          className="dropdown-item"
                          onClick={handleSignInClick}
                        >
                          Sign In
                        </span>
                        <span
                          className="dropdown-item"
                          onClick={handleSignUpClick}
                        >
                          Sign Up
                        </span>
                        <a
                          href="https://adminpanel.taggeo.in/login"
                          target="_blank"
                          className="dropdown-item"
                        >
                          Admin Login
                        </a>
                      </div>
                      <Dropdown menu={{ items }} trigger={['click']} >
    <Button type="text" style={{backgroundColor:"white",padding:"20px"}}> 
      Sign In / Sign Up <DownOutlined />
    </Button>
  </Dropdown>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <h1 className="hero-title">
              Empower your learning
              <br />
              journey now
            </h1>
            <p className="hero-description">
              Discover limitless learning opportunities with thousands of
              courses available anytime, anywhere, all at unbeatable prices
            </p>
          </div>
        </section> */}
        
        {/* Features Section */}
        <section className="features-section">
          <div className="features-content">
            <div className="timeline-container">
              <div className="features-header">
                <span className="features-tag">Management</span>
                <h2 className="features-title">
                  We provides you world class performance.
                </h2>
              </div>
              {/* <div> */}
                <div className="benefit-card">
                  <div className="benefit-marker blue" />
                  <img
                    src={BenefitImage}
                    alt="benefit-images"
                    className="benefit-icon"
                  />
                  <div className="benefit-content">
                    <h3 className="benefit-title">9 Online courses</h3>
                    <p className="benefit-description">
                      Explore a wide range of fresh topics to expand your
                      knowledge and skills. Whether you're interested in
                      cutting-edge technology
                    </p>
                  </div>
                </div>
                <div className="benefit-card">
                  <div className="benefit-marker blue" />
                  <img
                    src={BenefitImage2}
                    alt="benefit-images"
                    className="benefit-icon"
                  />
                  <div className="benefit-content">
                    <h3 className="benefit-title">Expert instruction</h3>
                    <p className="benefit-description">
                      Discover courses that match your goals, interests, and skill
                      level. Whether you're starting fresh or advancing your
                      career, there's something for everyone.
                    </p>
                  </div>
                </div>
                <div className="benefit-card">
                  <div className="benefit-marker blue" />
                  <img
                    src={BenefitImage3}
                    alt="benefit-images"
                    className="benefit-icon"
                  />
                  <div className="benefit-content">
                    <h3 className="benefit-title">Smart solution</h3>
                    <p className="benefit-description">
                      Enjoy the flexibility to study anytime, anywhere, at your
                      own pace. Balance learning with your work, family, or daily
                      routine effortlessly.
                    </p>
                  </div>
                </div>
                <div className="benefit-card">
                  <div className="benefit-marker blue" />
                  <img
                    src={BenefitImage4}
                    alt="benefit-images"
                    className="benefit-icon"
                  />
                  <div className="benefit-content">
                    <h3 className="benefit-title">Built for Excellence</h3>
                    <p className="benefit-description">
                      Ake control of your
                      <span className="text-bold">finances by</span>
                      setting and tracking budgets
                    </p>
                  </div>
                </div>
                <div className="benefit-card">
                  <div className="benefit-marker blue" />
                  <img
                    src={BenefitImage5}
                    alt="benefit-images"
                    className="benefit-icon"
                  />
                  <div className="benefit-content">
                    <h3 className="benefit-title">Dynamic Customization</h3>
                    <p className="benefit-description">
                      Easily monitor and manage your
                      <span className="text-bold">expenses with our</span>
                      intuitive.
                    </p>
                  </div>
                </div>
                <div className="benefit-card">
                  <div className="benefit-marker blue" />
                  <img
                    src={BenefitImage6}
                    alt="benefit-images"
                    className="benefit-icon"
                  />
                  <div className="benefit-content">
                    <h3 className="benefit-title">Seamless Integration</h3>
                    <p className="benefit-description">
                      Ake control of your
                      <span className="text-bold">finances by</span>
                      setting and tracking budgets.
                    </p>
                  </div>
                </div>
              {/* </div> */}
            </div>
          </div>
        </section>
        {/* Team Section */}
        <section className="team-section">
          <div className="team-container">
            <div className="team-header">
              <div className="team-header-content">
                <span className="team-label">OUR TEAM</span>
                <h2 className="team-title">Top instructors</h2>
              </div>
            </div>
            <div className="team-grid">
              <div className="team-row">
                {instructors.map((item, index) => (
                  <div key={item.id || index} className="team-box">
                    <img
                      src={
                        item?.image == null
                          ? images.broken_instructor_jpg
                          : `${image_base_url}${item.image}`
                      }
                      alt={`${item.firstName}'s profile`}
                      className="team-member"
                    />
                    <h2 className="team-name">
                      {item.firstName ? item?.firstName : "Name"}
                    </h2>
                    <span>Instructor</span>
                  </div>
                ))}
                {/* <div className="team-box">
                  <img
                    src={InstrImage}
                    alt="Team Member 1"
                    className="team-member"
                  />
                  <h2 className="team-name">Joseph G. Brown</h2>
                  <span>Instructors</span>

                </div>
                <div className="team-box">
                  <img
                    src={InstrImage2}
                    alt="Team Member 2"
                    className="team-member"
                  />
                  <h2 className="team-name">Joseph G. Brown</h2>
                  <span>Instructors</span>
                </div>
                <div className="team-box">
                  <img
                    src={InstrImage3}
                    alt="Team Member 3"
                    className="team-member"
                  />
                  <h2 className="team-name">Joseph G. Brown</h2>
                  <span>Instructors</span>
                </div>

              </div>
              <div className="team-row">
                <div className="team-box">
                  <img
                    src={InstrImage4}
                    alt="Team Member 4"
                    className="team-member"
                  />
                  <h2 className="team-name">Joseph G. Brown</h2>
                  <span>Instructors</span>
                </div>
                <div className="team-box">
                  <img
                    src={InstrImage5}
                    alt="Team Member 5"
                    className="team-member"
                  />
                  <h2 className="team-name">Joseph G. Brown</h2>
                  <span>Instructors</span>
                </div>
                <div className="team-box">
                  <img
                    src={InstrImage6}
                    alt="Team Member 6"
                    className="team-member"
                  />
                  <h2 className="team-name">Joseph G. Brown</h2>
                  <span>Instructors</span>
                </div> */}
              </div>
            </div>
          </div>
        </section>
        {/* CTA Section */}
        <section className="cta-section">
          <div className="cta-container">
            <img
              src={CtaImage}
              alt="CTA Background"
              className="cta-background"
            />
            <div className="cta-content">
              <h3 className="cta-subtitle">
                Learn from our quality instructors!
              </h3>
              <h2 className="cta-title">Join now to start learning</h2>
            </div>
            <div className="cta-buttons">
              {isAuthenticated() ? (
                <button
                  className="cta-button primary"
                  onClick={() => navigate("/courses")}
                >
                  Get Started
                </button>
              ) : (
                <button
                  className="cta-button secondary"
                  onClick={() => navigate("/signup")}
                >
                  <span className="button-text">Join Now</span>
                  <img src={JoinNow} alt="Arrow" className="button-icon" />
                </button>
              )}

              {/* <button className="cta-button secondary"
                 onClick={() => navigate('/signup')}
              >
                <span className="button-text">Join Now</span>
                <img
                  src={JoinNow}
                  alt="Arrow"
                  className="button-icon"
                />
              </button> */}
            </div>
          </div>
        </section>
        {/* Footer Section */}
        {/* <footer className="footer-section">
          <div className="footer-container">
            <div className="footer-main">
              <div className="footer-about">
                <img
                  src={Lmslogo}
                  alt="LMS Logo"
                  className="footer-logo"
                />
                <p className="footer-description">
                  Discover a World of Possibilities with TripNavigator Tours.
                </p>
              </div>
              <div className="footer-content">
                <div className="newsletter">
                  <h3 className="newsletter-title">Subscribe to Newsletter</h3>
                  <div className="newsletter-form">
                    <div className="form-container">
                      <input
                        type="email"
                        placeholder="Your email"
                        className="email-input"
                      />
                      <button className="subscribe-button">Subscribe</button>
                    </div>
                  </div>
                </div>
                <div className="footer-links">
                  <div className="footer-column">
                    <h3 className="column-title">Resources</h3>
                    <div className="column-links">
                      <a onClick={handleCourse} className="footer-link">
                        My Courses
                      </a>
                      <a onClick={handleCourse} className="footer-link">
                        Courses
                      </a>
                      <a onClick={contactPage} className="footer-link">
                        Contact us
                      </a>
                    </div>
                  </div>
                  <div className="footer-column">
                    <h3 className="column-title">Legal</h3>
                    <div className="column-links">
                      <a onClick={handleTerms} className="footer-link">
                        Terms of Service
                      </a>
                      <a onClick={handlePolicy} className="footer-link">
                        Privacy Policy
                      </a>
                      <a onClick={handleLogout} className="footer-link">
                        logout
                      </a>
                    </div>
                  </div>
                  <div className="footer-column">
                    <h3 className="column-title">Contact</h3>
                    <div className="column-links">
                      <p className="contact-info">+91-9199569685</p>
                      <p className="contact-info">A: </p>
                    </div>
                    <div className="social-box">
                      <div className="social-icons">
                        <img
                          src={SociaMedia}
                          alt="Social Media Icons"
                          className="social-image"
                        />
                      </div>
                      <div className="social-icons2">
                        <img
                          src={SociaMedia2}
                          alt="Social Media Icons"
                          className="social-image"
                        />
                      </div>
                      <div className="social-icons3">
                        <img
                          src={SociaMedia3}
                          alt="Social Media Icons"
                          className="social-image"
                        />
                      </div>
                      <div className="social-icons4">
                        <img
                          src={SociaMedia4}
                          alt="Social Media Icons"
                          className="social-image"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-bottom">
              <div className="footer-bottom-container">
                <div className="copyright">
                  <p className="copyright-text"> &#169; lms 2025 All right reserved.</p>
                </div>
                <div className="contact-details">
                  <div className="contact-item">
                    <img
                      src={EmailIcon}
                      alt="Email Icon"
                      className="contact-icon"
                    />
                    <p className="contact-text">info@lms.com</p>
                  </div>
                  <div className="contact-item">
                    <img
                      src={PhoneIcon}
                      alt="Phone Icon"
                      className="contact-icon"
                    />
                    <p className="contact-text">+91-9199569685</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer> */}
        {/* <Footer /> */}
      </div>
    </>
  );
};

export default Body;
